import { updateObject } from './../../utils/utility';

const initialState = {
    totalElements: 0,
    pageNumber: 0,
    totalPages: 0,
    businessReportList: [],
}

const setBusinessReportList = (state = initialState, action) => {
    const data = action.payload.data;
    return updateObject(state, {
        businessReportList: data.businessReportList,
        totalElements: data.totalElements,
        pageNumber: data.pageNumber,
        totalPages: data.totalPages
    });
};

const reducer = (state = initialState, action) => {
     if (action.type === "SET_BUSINESS_REPORT_LIST") {
        return setBusinessReportList(state, action);
    }
    return state;
};

export default reducer;